import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField, NullableInput} from "../../Shared/InputField"

const DebitLocationForm = () => {
  const [errors, setErrors] = useState({})
  const [isLoading, setIsLoading] = useState(false)

  const [formData, setFormData] = useState({
    date: new Date().toISOString().slice(0, 10),
    remark: "",
    location_id: "",
    amout: "",
  })
  const {date, remark, location_id, amount} = formData

  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {

    if (location.state){
        const {location_id} = location.state
        setFormData((prev) => ({
            ...prev,
            location_id: location_id
        }))
    }
      
  }, [])  

  const onChange = (e) => {
      setFormData((prevState) => ({
          ...prevState,
          [e.target.name]: e.target.value
      }))
  }

  const onSubmit = (e) => {
      e.preventDefault()

      const paylaod = {date, remark, location_id, amount}
      disconnectLocation(paylaod)
  }
  
  const disconnectLocation = async (paylaod) => {
      setIsLoading(true)
      try {
          const response = await Server.post('/locations/debit', paylaod)
          navigate('/locations-serverside')
          setIsLoading(false)
          toast.success(response.data.detail)
      } catch (error) {
          setIsLoading(false)
          if(error.response.status === 401){
              navigate('/login')
          }else if (error.response.status === 422){
            setErrors({})
            error.response?.data?.detail.map((err) => (
                setErrors((prevState) => ({
                    ...prevState,
                    [err.loc[1]]: err.msg
                }))
            ))
        }else if (error.response.status === 403){
            toast.error(error.response.data.detail);
            navigate('/');
        }else {
            toast.error(error.response?.data?.detail)
        }
      }
  }

  if(isLoading){
      return <Spinner/>
  }

return (
  <>
    <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Debit Location Form</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-2">
                            <InputField
                                name="location_id"
                                type="number"
                                label="ID"
                                value={location_id}
                                onChange={onChange}
                                error={errors.location_id}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                name="date"
                                type="date"
                                label="Date"
                                value={date}
                                onChange={onChange}
                                error={errors.date}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                name="amount"
                                type="number"
                                label="Debit Amount"
                                value={amount}
                                onChange={onChange}
                                error={errors.amount}
                            />
                        </div>
                        <div className="col-md-4">
                            <NullableInput
                                placeholder="Remark"
                                name="remark"
                                type="text"
                                label="Remark"
                                value={remark}
                                onChange={onChange}
                                error={errors.remark}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Debit" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
  </>
)
}

export default DebitLocationForm
